import { Role } from '@/models/AccountEnums';
import { encodeCusipForUrl } from './encodeCusipForUrl';

/** Roles that may use the feed classification endpoints. */
export type ClassificationScope = Role.Firm | Role.Advisor;

export const ADVISOR_HOLDINGS_URL = '/api/advisor/Holdings';

export function getClassificationScope(
  role: Role | null | undefined,
): ClassificationScope | null {
  if (role === Role.Firm) {
    return Role.Firm;
  }
  if (role === Role.Advisor) {
    return Role.Advisor;
  }
  return null;
}

function firmGroupUrl(advisorGroupId: number | null, path: string): string {
  return `/api/firm/advisorGroups/${String(advisorGroupId)}${path}`;
}

export const classificationUrls = {
  cusips: (
    scope: ClassificationScope,
    advisorGroupId: number | null,
  ): string =>
    scope === Role.Firm
      ? firmGroupUrl(advisorGroupId, '/Cusips')
      : '/api/advisor/Cusips',

  cusipsExport: (
    scope: ClassificationScope,
    advisorGroupId: number | null,
  ): string =>
    scope === Role.Firm
      ? firmGroupUrl(advisorGroupId, '/CusipsExport')
      : '/api/advisor/CusipsExport',

  unclassifiedCusips: (
    scope: ClassificationScope,
    advisorGroupId: number | null,
  ): string =>
    scope === Role.Firm
      ? firmGroupUrl(advisorGroupId, '/unclassifiedCusips/')
      : '/api/advisor/UnclassifiedCusips',

  cusipDiversifications: (
    scope: ClassificationScope,
    advisorGroupId: number | null,
    cusip: string,
  ): string => {
    const encoded = encodeCusipForUrl(cusip);
    return scope === Role.Firm
      ? firmGroupUrl(advisorGroupId, `/cusips/${encoded}/diversifications`)
      : `/api/advisor/Cusips/${encoded}/Diversifications`;
  },

  cusipDiversification: (
    scope: ClassificationScope,
    advisorGroupId: number | null,
    cusip: string,
    masterSecuritiesOverrideId: number,
  ): string =>
    `${classificationUrls.cusipDiversifications(scope, advisorGroupId, cusip)}/${String(masterSecuritiesOverrideId)}`,

  bulkEditCusipDiversifications: (scope: ClassificationScope): string =>
    scope === Role.Firm
      ? '/api/firm/bulkEditCusipDiversifications'
      : '/api/advisor/BulkEditCusipDiversifications',

  holdingDiversifications: (
    scope: ClassificationScope,
    wealthHoldingId: number,
  ): string =>
    `/api/${scope === Role.Firm ? 'firm' : 'advisor'}/Holdings/${String(wealthHoldingId)}/Diversifications`,
};
